export var Name = 'handle-partial-view-analytics';
export var HandlePartialViewAnalytics = Name;